import { getToken, getUser, setAuth } from "@/services/api/auth.js";
import { apiRequest } from "@/services/api/apiClient.js";
import { setMePermissionsManagement } from "@/services/api/permissionManagement.js";
import { useAuthStore } from "@/stores/authStore.js";

export const setCorp = async ({ id, advancedCredentials = null }) => {
    const authStore = useAuthStore(); // ✅ instancia o store

    try {
        let response = "";
        let user = "";
        let token = "";

        if (!advancedCredentials) {
            response = await apiRequest({
                client: window.API_AUTH,
                method: "post",
                url: `/setCorp/${id}`,
            });
        } else {
            user = getUser();
            token = getToken();
            response = user.fullUser;
        }

        localStorage.setItem(
            "corp",
            advancedCredentials ? "*" : response.credentials.corp,
        );

        await setAuth({
            token: advancedCredentials ? token : response.access_token,
            credentials: advancedCredentials
                ? user.fullUser
                : response.credentials,
        });

        authStore.scheduleTokenRefresh();

        await setMePermissionsManagement({
            id: advancedCredentials ? user.id : response?.credentials?.user?.id,
            advancedCredentials,
        });

        await authStore.fetchPermissions();

        return response;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const listCorps = async ({ companyName = null }) => {
    const credentialsStr = localStorage.getItem("credentials");
    if (!credentialsStr) {
        return [];
    }
    try {
        const credentials = JSON.parse(credentialsStr);
        const corps = credentials?.user?.corps ?? {};

        let corpsObj = Object.values(corps).map((c) => ({
            id: c.id,
            companyName: c.company_name,
        }));

        if (
            credentials?.permission?.admin?.[0] === "*" &&
            credentials?.permission?.allow?.[0] === "*"
        ) {
            corpsObj.push({
                id: "*",
                companyName: "Administrador",
            });
        }

        // 🔥 tratamento do %nome%
        if (companyName) {
            const search = companyName.replace(/%/g, "").toLowerCase();

            corpsObj = corpsObj.filter((corp) =>
                corp.companyName?.toLowerCase().includes(search),
            );
        }
        return corpsObj;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getCorp = async () => {
    const credentialsStr = localStorage.getItem("credentials");
    const corpId = localStorage.getItem("corp");

    if (!credentialsStr || !corpId || corpId === "*") {
        return null;
    }

    try {
        const credentials = JSON.parse(credentialsStr);
        const corps = credentials?.user?.corps ?? {};
        const corpEntry = Object.entries(corps).find(
            ([authName, corp]) => corp.id === corpId,
        );

        if (!corpEntry) return null;

        const [authName, corp] = corpEntry;

        return {
            id: corp.id,
            companyName: corp.company_name,
            authName: authName,
        };
    } catch (error) {
        return Promise.reject(error);
    }
};

export const addUsertoCorp = async ({ idCorp, idUser }) => {
    try {
        return await apiRequest({
            client: window.API_AUTH,
            method: "post",
            url: `/corp/${idCorp}/addUser/${idUser}`,
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export async function getCorpUsers({
    page = 1,
    orderBy = [],
    limit = 10,
    ...filters
}) {
    try {
        const corp = await getCorp();
        const url = corp ? `/corp/${corp.id}/users` : "user";

        return await apiRequest({
            client: window.API_AUTH,
            method: "get",
            orderBy,
            url: url,
            params: { page, limit, ...filters },
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export async function updateCorp({ business_name, id }) {
    try {
        await apiRequest({
            client: window.API_AUTH,
            method: "put",
            url: `/corp/${id}`,
            body: {
                business_name: business_name,
            },
        });
    } catch (error) {
        return Promise.reject(error);
    }
}
